export default __webpack_public_path__ + "static/media/eisfuchs-logo.536c4f80.svg";